import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { HotkeyService } from "../../services/hotkey.service";

@Component({
  selector: "ch-search-box",
  templateUrl: "./search-box.component.html",
  styleUrls: ["./search-box.component.less"],
})
export class SearchBoxComponent implements OnInit, OnDestroy {
  @Input()
  placeholder: string;
  @Input()
  focusOnInit = false;
  @Input()
  focusHotkey: string;
  @Input()
  focusHotkeyDescription: string;

  @Output()
  valueChange = new EventEmitter<string>();
  @Output()
  enterKey = new EventEmitter<void>();

  @ViewChild("searchInput") searchInput;

  searchTerm: string;

  private unregisterHotkey: (() => void) | null = null;

  constructor(private readonly hotkeyService: HotkeyService) {}

  ngOnInit() {
    if (this.focusHotkey) {
      this.unregisterHotkey = this.hotkeyService.register(this.focusHotkey, this.focusHotkeyDescription, () =>
        this.focus(),
      );
    }
  }

  ngOnDestroy() {
    this.unregisterHotkey?.();
  }

  focus() {
    // why this doesn't work without setTimeout()?
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 0);
  }

  clearClick(e: any) {
    // if this component is in a dropdown, this button shouldn't close it
    e.stopPropagation();
    this.clear();
  }

  clear() {
    this.searchTerm = null;
    this.valueChange.emit(this.searchTerm);
  }

  searchKeyEvent(e: any) {
    if (e.keyCode === 13) {
      // enter
      // the search can be cleared (at least in the workflow view)
      this.searchTerm = null;
      this.enterKey.emit();
    }

    if (e.keyCode === 27) {
      // escape key
      // don't close the dropdown if there is something to clear
      if (this.searchTerm) {
        e.stopPropagation();
      }
      this.clear();
    } else {
      this.valueChange.emit(this.searchTerm);
    }
  }
}
